import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AccessDeniedPage from '../pages/AccessDeniedPage';
import GlobalLoader from '../components/GlobalLoader';

function PermissionRoute({
    children,
    permission,
    permissions = [],
    requireReactAccess = true,
}) {
    const location = useLocation();
    const { isAuthenticated, can, canAny, status, isAuthRefreshing } = useAuth();

    if (status === 'loading' || isAuthRefreshing) {
        return <GlobalLoader message="Validando sesión y permisos..." minHeight="70vh" />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireReactAccess && !can('access.react_tecnicos')) {
        return (
            <AccessDeniedPage
                title="Acceso a app tecnica no habilitado"
                description="Tu usuario no tiene habilitado access.react_tecnicos."
            />
        );
    }

    const hasRequiredPermission = permission
        ? can(permission)
        : (permissions.length > 0 ? canAny(permissions) : true);

    if (!hasRequiredPermission) {
        return (
            <AccessDeniedPage
                title="Permiso insuficiente"
                description={`Falta permiso ${permission || permissions.join(' o ')} para acceder a esta ruta.`}
            />
        );
    }

    return children;
}

export default PermissionRoute;
